(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    const mq = window.matchMedia('(min-width: 750px)');
    const details = () => document.querySelectorAll('.footer__column');

    const sync = () => {
      details().forEach((el) => {
        if (mq.matches) {
          el.setAttribute('open', '');
        } else {
          el.removeAttribute('open');
        }
      });
    };

    sync();
    mq.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-video"] && !Shopify.designMode) return;
  try {
    
(function() {
  var players = document.querySelectorAll('[data-video-player]');
  if (!players.length) return;

  var ytSeq = 0;
  var ytApiPromise = null;

  // Load the YouTube IFrame Player API once, on first play. Resolves when
  // window.YT.Player is available. Chains any existing onYouTubeIframeAPIReady
  // so we cooperate with other sections that use the same global API.
  function loadYoutubeApi() {
    if (window.YT && window.YT.Player) return Promise.resolve();
    if (ytApiPromise) return ytApiPromise;
    ytApiPromise = new Promise(function(resolve) {
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function() {
        if (typeof prev === 'function') { try { prev(); } catch (e) {} }
        resolve();
      };
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
      }
    });
    return ytApiPromise;
  }

  function ytSend(iframe, func) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(
      JSON.stringify({ event: 'command', func: func, args: [] }),
      '*'
    );
  }

  function pauseAllYoutubeExcept(currentIframe) {
    document.querySelectorAll('[data-video-player] iframe').forEach(function(iframe) {
      if (iframe !== currentIframe) ytSend(iframe, 'pauseVideo');
    });
  }

  function ensureYoutubeIframe(player, autoplay) {
    var existing = player.querySelector('iframe');
    if (existing) return existing;
    var ytId = player.dataset.youtubeId;
    if (!ytId) return null;
    var params = ['rel=0', 'enablejsapi=1', 'playsinline=1', 'autoplay=1'];
    if (autoplay) {
      params.push('mute=1', 'loop=1', 'playlist=' + ytId);
    }
    var iframe = document.createElement('iframe');
    iframe.id = 'media-video-yt-' + (++ytSeq);
    iframe.src = 'https://www.youtube.com/embed/' + ytId + '?' + params.join('&');
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.title = player.dataset.videoTitle || 'Video';
    var trigger = player.querySelector('[data-video-trigger]');
    if (trigger) trigger.remove();
    player.appendChild(iframe);
    // autoplay=1 starts playback where the browser's autoplay policy allows it.
    // For everyone else, attach the IFrame Player API and call playVideo() on
    // onReady — the only reliable way to start a single-click play. (Posting
    // playVideo on the iframe `load` event fires before the player API is
    // listening, so it's dropped.) Mirrors the previous theme's DeferredMedia.
    loadYoutubeApi().then(function() {
      try {
        new window.YT.Player(iframe.id, {
          events: {
            onReady: function(e) { e.target.playVideo(); }
          }
        });
      } catch (e) {}
    });
    return iframe;
  }

  function revealHtml5Video(player, mutedAutoplay) {
    var v = player.querySelector('video[data-video-element]');
    if (!v) return null;
    v.hidden = false;
    var trigger = player.querySelector('[data-video-trigger]');
    if (trigger) trigger.remove();
    if (mutedAutoplay) {
      v.muted = true;
      v.controls = false;
    } else {
      v.muted = false;
      v.controls = true;
    }
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function() {});
    return v;
  }

  players.forEach(function(player) {
    var trigger = player.querySelector('[data-video-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', function() {
      var type = player.dataset.sourceType;
      if (type === 'youtube') {
        pauseAllYoutubeExcept(null);
        ensureYoutubeIframe(player, false);
      } else if (type === 'shopify' || type === 'url') {
        revealHtml5Video(player, false);
      }
    });
  });

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var player = entry.target;
      var type = player.dataset.sourceType;
      if (entry.isIntersecting) {
        if (type === 'youtube') {
          ensureYoutubeIframe(player, true);
        } else if (type === 'shopify' || type === 'url') {
          var v = player.querySelector('video[data-video-element]');
          if (v && v.hidden) {
            revealHtml5Video(player, true);
          } else if (v) {
            v.muted = true;
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function() {});
          }
        }
      } else {
        if (type === 'youtube') {
          var iframe = player.querySelector('iframe');
          if (iframe) ytSend(iframe, 'pauseVideo');
        } else {
          var v = player.querySelector('video[data-video-element]');
          if (v && !v.hidden) v.pause();
        }
      }
    });
  }, { threshold: 0.5 });

  players.forEach(function(player) {
    if (player.dataset.autoplayInView === 'true') observer.observe(player);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    // Mobile Content/Products tab switcher. On desktop both columns show; on
    // mobile only the active tab is visible. Tab counts stay in sync as the
    // metaobject client appends content rows (watched via MutationObserver).
    class SearchTabManager {
      constructor() {
        this.tabContainer = document.getElementById('search-tabs');
        this.contentResults = document.getElementById('search-content-results');
        this.productResults = document.getElementById('search-product-results');
        this.activeTab = 'content';
        if (this.tabContainer && this.contentResults && this.productResults) {
          this.init();
        }
      }

      init() {
        this.updateCounts();
        this.setupTabButtons();
        this.observeResults();
        window.addEventListener('resize', () => this.handleResize());

        if (this.getContentCount() === 0 && this.getProductCount() > 0) {
          this.switchTab('products');
        }
      }

      handleResize() {
        if (window.innerWidth > 749) {
          this.updateCounts();
        } else {
          this.switchTab(this.activeTab);
        }
      }

      setupTabButtons() {
        this.tabContainer.querySelectorAll('.search-tab-button').forEach((button) => {
          button.addEventListener('click', () => this.switchTab(button.dataset.tab));
        });
      }

      switchTab(tab) {
        this.activeTab = tab;
        this.tabContainer.querySelectorAll('.search-tab-button').forEach((btn) => {
          btn.classList.toggle('active', btn.dataset.tab === tab);
        });
        this.contentResults.classList.toggle('active', tab === 'content');
        this.productResults.classList.toggle('active', tab === 'products');

        if (window.innerWidth > 749) {
          this.contentResults.style.display = this.getContentCount() === 0 ? 'none' : 'block';
          this.productResults.style.display = this.getProductCount() === 0 ? 'none' : 'block';
        } else {
          // Clear any inline display set on desktop so the .active CSS rules win.
          this.contentResults.style.display = '';
          this.productResults.style.display = '';
        }
      }

      updateCounts() {
        const contentCount = this.getContentCount();
        const productCount = this.getProductCount();

        const contentCountSpan = this.tabContainer.querySelector('[data-count="content"]');
        const productCountSpan = this.tabContainer.querySelector('[data-count="products"]');
        if (contentCountSpan) contentCountSpan.textContent = contentCount;
        if (productCountSpan) productCountSpan.textContent = productCount;

        if (window.innerWidth > 749) {
          const loading = this.contentResults.querySelector('#metaobject-loading-inline');
          const loadingVisible = loading && loading.style.display !== 'none';
          this.contentResults.style.display = contentCount === 0 && !loadingVisible ? 'none' : 'block';
          this.productResults.style.display = productCount === 0 ? 'none' : 'block';
        }
      }

      getContentCount() {
        const items = this.contentResults.querySelectorAll('.search-result-item').length;
        const loading = this.contentResults.querySelector('#metaobject-loading-inline');
        const loadingVisible = loading && loading.style.display !== 'none';
        return loadingVisible && items === 0 ? 1 : items;
      }

      getProductCount() {
        return this.productResults.querySelectorAll('[data-collection-card]').length;
      }

      observeResults() {
        const contentItems = this.contentResults.querySelector('.search-results-items');
        if (contentItems) {
          new MutationObserver(() => this.updateCounts()).observe(contentItems, { childList: true });
        }
      }
    }

    const start = () => { window.searchTabManager = new SearchTabManager(); };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team"] && !Shopify.designMode) return;
  try {
    
/*
  Team bio expand/collapse — used by the Two Column and Three Column layouts.
  Cards opt in by wrapping the bio + toggle in a [data-team-bio-root] element.

  Behaviour:
  - On init, measures the bio. If the truncated bio already shows everything
    (scrollHeight fits within clientHeight), the toggle is hidden because
    there's nothing to expand to.
  - On click, toggles `is-expanded` on the root. The line-clamp CSS reads
    that class to lift the truncation. Button text + aria-expanded swap.
  - Re-runs on Shopify theme editor section reloads via shopify:section:load.
  - Lives in a section-level javascript block (auto-bundled and deduped by
    Shopify), so the code loads exactly once per page even if multiple team
    sections render.
*/
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.teamBioInit === 'true') return;
    root.dataset.teamBioInit = 'true';

    var btn = root.querySelector('[data-team-bio-toggle]');
    var bio = root.querySelector('[data-team-bio]');
    if (!btn || !bio) return;

    /* Update the label span only, leaving the chevron SVG sibling untouched.
       Falls back to the button itself if no label span is present, which
       keeps the JS compatible with consumers that don't include a chevron. */
    var labelEl = btn.querySelector('[data-team-bio-toggle-label]') || btn;
    var labelMore = btn.getAttribute('data-label-more') || 'Read more';
    var labelLess = btn.getAttribute('data-label-less') || 'Read less';

    function hideIfFits() {
      if (root.classList.contains('is-expanded')) return;
      if (bio.scrollHeight <= bio.clientHeight + 1) {
        btn.hidden = true;
      } else {
        btn.hidden = false;
      }
    }

    /* Multi-stage measurement so the toggle accurately reflects whether the
       bio overflows the clamped height. Initial RAF catches the common case
       once the line-clamp CSS has applied. fonts.ready handles web-font
       reflow (line-height can change a hair when the real font swaps in).
       ResizeObserver catches any subsequent container-width changes (e.g.,
       theme editor resizing the preview frame) without polling. */
    requestAnimationFrame(hideIfFits);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(hideIfFits);
    }
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(hideIfFits);
      ro.observe(bio);
    }

    btn.addEventListener('click', function () {
      var expanded = root.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      labelEl.textContent = expanded ? labelLess : labelMore;
    });

    /* Resize fallback for browsers without ResizeObserver. */
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(hideIfFits, 150);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-team-bio-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();


/*
  Team Three Column — tag-pill width fitter.

  Without JS the tag pill works fine for short tags (width: fit-content
  hugs single-line content) but for tags whose natural width exceeds the
  card column, the text wraps inside a pill whose background still spans
  the full column — block-level boxes can't hug wrapped text in CSS, the
  box dimensions are computed before line wrapping.

  This script measures the already-wrapped lines of each pill with a
  Range, finds the widest line, and sets an inline `width` on the pill
  equal to that widest line + horizontal padding. Effect: the pill
  background visually hugs the widest wrapped line as one continuous
  rounded rectangle, while the text itself re-wraps to the same lines
  inside the narrower box. Short single-line pills are skipped.

  Lifecycle: initial DOM ready, font load, debounced resize, and the
  theme editor's section:load event.
*/
(function () {
  'use strict';

  function fitPill(pill) {
    /* Clear any inline width from a previous run so the measurement
       reflects the natural CSS-driven wrap at the current viewport. */
    pill.style.width = '';

    var range = document.createRange();
    range.selectNodeContents(pill);
    var rects = range.getClientRects();
    if (range.detach) range.detach();

    /* One rect = text already fits on one line; CSS fit-content has it. */
    if (!rects || rects.length <= 1) return;

    var widest = 0;
    for (var i = 0; i < rects.length; i++) {
      if (rects[i].width > widest) widest = rects[i].width;
    }

    var cs = window.getComputedStyle(pill);
    var extra = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight) +
                parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);

    /* +2px safety against sub-pixel rounding: if the computed width
       lands a fraction below the actual widest line, the text re-wraps
       to an extra line inside the narrower box. The 2px headroom keeps
       the line count stable. */
    pill.style.width = (Math.ceil(widest + extra) + 2) + 'px';
  }

  function fitAll(scope) {
    var pills = (scope || document).querySelectorAll('.team--three-column .team__card-tag');
    for (var i = 0; i < pills.length; i++) fitPill(pills[i]);
  }

  function boot() {
    fitAll();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { fitAll(); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var resizeT = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () { fitAll(); }, 100);
  });

  document.addEventListener('shopify:section:load', function (e) { fitAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-ugc"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /**
   * initVideoUgc — boots one [data-video-ugc] component.
   * Guard flag `data-video-ugc-init` prevents double-init on
   * Shopify theme editor section:load events.
   *
   * Slot management: all video slots are pre-rendered in the DOM;
   * the active one loses the `hidden` attribute while the others have it.
   * JS never needs to build or clone markup.
   *
   * Controls are bound per-slot on first activation so events don't
   * pile up across switches. Each slot tracks its own listeners via
   * a `_ugcBound` flag.
   */
  function initVideoUgc(root) {
    if (root.dataset.videoUgcInit === 'true') return;
    root.dataset.videoUgcInit = 'true';

    var slots      = Array.from(root.querySelectorAll('[data-video-ugc-slot]'));
    var thumbBtns  = Array.from(root.querySelectorAll('[data-video-ugc-thumb]'));
    var thumbItems = Array.from(root.querySelectorAll('.video-ugc__thumb'));

    if (slots.length === 0) return;

    var activeIndex  = 0;
    var currentVideo = null;

    /* ── Helpers ─────────────────────────────────────────────── */

    /** Format seconds as M:SS */
    function fmt(t) {
      if (!isFinite(t) || t < 0) return '0:00';
      var m = Math.floor(t / 60);
      var s = Math.floor(t % 60);
      return m + ':' + (s < 10 ? '0' + s : s);
    }

    /** Update player time display + main progress bar.
        Note: the thumbnail active-state bar is purely a CSS indicator
        (toggled by the .video-ugc__thumb--active class on switchTo).
        No JS width animation — it stays a static full-width purple bar
        when the thumb is selected. */
    function updateTime(video, slot, progressFill, timeEl, progressBtn) {
      var pct = video.duration ? (video.currentTime / video.duration) : 0;

      if (timeEl) timeEl.textContent = fmt(video.currentTime) + ' / ' + fmt(video.duration);
      if (progressFill) progressFill.style.width = (pct * 100) + '%';
      if (progressBtn) progressBtn.setAttribute('aria-valuenow', Math.round(pct * 100));
    }

    /* ── Controls binding (per slot, idempotent) ─────────────── */

    /**
     * bindControls — attaches play/pause/sound/fullscreen/seek listeners to a
     * slot that contains an uploaded <video>. Safe to call multiple times on
     * the same slot (guarded by slot._ugcBound).
     */
    function bindControls(slot) {
      var video = slot.querySelector('[data-video-ugc-video]');
      if (!video) return null;
      if (slot._ugcBound) return { video: video };

      slot._ugcBound = true;

      var playBtn      = slot.querySelector('[data-video-ugc-play]');
      var soundBtn     = slot.querySelector('[data-video-ugc-sound]');
      var fullscreenBtn = slot.querySelector('[data-video-ugc-fullscreen]');
      var timeEl       = slot.querySelector('[data-video-ugc-time]');
      var progressBtn  = slot.querySelector('[data-video-ugc-progress]');
      var progressFill = slot.querySelector('[data-video-ugc-progress-fill]');

      /* Centralised play — starts playback WITHOUT unmuting. Browsers (mobile
         Safari + Chrome on iOS in particular) reject programmatic play() calls
         that also unmute a video if the gesture chain isn't recognised as a
         direct user interaction; the older implementation that auto-unmuted on
         every play() was the source of the "autoplay is buggy on mobile"
         report — tapping a thumbnail kicked off an unmute + play sequence the
         browser blocked, and the new clip never started. The video stays muted
         (matching the initial state set at the bottom of this function); the
         user explicitly unmutes via the sound button when they want audio.
         Shared by the play button, click-on-video, click-on-poster, and
         thumbnail nav. */
      function play() {
        video.play();
      }

      /* Toggle play/pause for the play button + click-on-video. */
      function togglePlay() {
        if (video.paused) {
          play();
        } else {
          video.pause();
        }
      }

      /* Mute / unmute */
      function toggleSound() {
        video.muted = !video.muted;
        slot.classList.toggle('is-muted', video.muted);
        if (soundBtn) {
          soundBtn.setAttribute('aria-label',
            video.muted ? 'Unmute' : 'Mute');
        }
      }

      /* Fullscreen — targets the player wrapper for a nicer expand */
      function toggleFullscreen() {
        var el = root.closest('.video-ugc__player') || slot;
        if (document.fullscreenElement) {
          document.exitFullscreen();
        } else if (el.requestFullscreen) {
          el.requestFullscreen();
        }
      }

      /* Progress seek via click on the bar */
      function seek(e) {
        if (!video.duration) return;
        var rect = progressBtn.getBoundingClientRect();
        var ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
        video.currentTime = ratio * video.duration;
      }

      if (playBtn) playBtn.addEventListener('click', togglePlay);
      if (soundBtn) soundBtn.addEventListener('click', toggleSound);
      if (fullscreenBtn) fullscreenBtn.addEventListener('click', toggleFullscreen);
      if (progressBtn) progressBtn.addEventListener('click', seek);

      /* Click on the video itself toggles play/pause. The controls overlay is
         a sibling of <video>, so its button clicks don't reach this handler. */
      video.addEventListener('click', togglePlay);

      /* Click on the poster (visible only before first play) starts playback. */
      var posterEl = slot.querySelector('.video-ugc__poster');
      if (posterEl) posterEl.addEventListener('click', play);

      /* Idle timer — fades out the controls after IDLE_MS of inactivity while
         playing. Resets on mousemove/touch over the slot. Cleared (and controls
         re-shown) on pause / ended so the user always sees them when paused. */
      var idleTimer = null;
      var IDLE_MS = 3000;

      function scheduleHide() {
        clearTimeout(idleTimer);
        idleTimer = setTimeout(function () {
          if (!video.paused) slot.classList.add('controls-hidden');
        }, IDLE_MS);
      }

      function showControls() {
        slot.classList.remove('controls-hidden');
        if (!video.paused) scheduleHide();
      }

      /* `has-played` is set on first play and never removed — it hides the
         poster `<img alt="" aria-hidden="true">` so the video frames are
         visible. Survives pause/ended so we don't flash the poster back in
         when the user pauses mid-video. Catches all playback starts (button
         click, autoplay, programmatic).
         Additionally, when ANY video in this section (or any other UGC
         section on the page) starts playing, pause + mute every other
         [data-video-ugc-video]. This means the user only ever hears one
         clip at a time, regardless of how many video-ugc sections coexist
         on the page or which control surface (button / thumbnail / swipe)
         triggered the play. */
      video.addEventListener('play',  function () {
        slot.classList.add('is-playing');
        slot.classList.add('has-played');
        scheduleHide();

        var allVideos = document.querySelectorAll('[data-video-ugc-video]');
        for (var i = 0; i < allVideos.length; i++) {
          var other = allVideos[i];
          if (other === video) continue;
          if (!other.paused) other.pause();
          other.muted = true;
          var otherSlot = other.closest('[data-video-ugc-slot]');
          if (otherSlot) otherSlot.classList.add('is-muted');
        }
      });
      video.addEventListener('pause', function () {
        slot.classList.remove('is-playing');
        clearTimeout(idleTimer);
        slot.classList.remove('controls-hidden');
      });
      video.addEventListener('ended', function () {
        slot.classList.remove('is-playing');
        clearTimeout(idleTimer);
        slot.classList.remove('controls-hidden');
      });

      /* Mouse / touch activity on the slot re-shows the controls. The swipe
         handler on the parent player element fires independently and isn't
         affected by these listeners. */
      slot.addEventListener('mousemove', showControls);
      slot.addEventListener('touchstart', showControls, { passive: true });

      video.addEventListener('timeupdate', function () {
        updateTime(video, slot, progressFill, timeEl, progressBtn);
      });

      video.addEventListener('loadedmetadata', function () {
        updateTime(video, slot, progressFill, timeEl, progressBtn);
      });

      /* Start muted for autoplay-friendly behaviour */
      video.muted = true;
      slot.classList.add('is-muted');

      return { video: video, play: play };
    }

    /* ── Slot switching ──────────────────────────────────────── */

    function switchTo(index, autoplay) {
      if (index === activeIndex) return;

      /* Pause + mute the currently active video. Muting in addition to
         pausing keeps the previous clip's audio state clean — if the user
         had unmuted before switching, the new clip still starts muted, and
         when they jump back to the old slot it doesn't unexpectedly emit
         audio. This works hand-in-hand with the 'play' event listener
         below that mutes every OTHER [data-video-ugc-video] on the page. */
      if (currentVideo) {
        if (!currentVideo.paused) currentVideo.pause();
        currentVideo.muted = true;
        var prevSlot = currentVideo.closest('[data-video-ugc-slot]');
        if (prevSlot) prevSlot.classList.add('is-muted');
      }

      /* Toggle slot visibility */
      slots.forEach(function (s, i) {
        if (i === index) {
          s.removeAttribute('hidden');
        } else {
          s.setAttribute('hidden', '');
        }
      });

      /* Toggle the active class — that's all the active-state visual needs.
         The .video-ugc__thumb--active CSS rule sets the bar's background-color
         to Primary/60; inactive thumbs are transparent. No width manipulation. */
      thumbItems.forEach(function (item, i) {
        item.classList.toggle('video-ugc__thumb--active', i === index);
      });

      /* If the thumbnail row is wider than its scroll port, smooth-scroll the
         newly-active thumb into view (centered when possible). Browsers ignore
         scrollIntoView's inline option for elements already visible, so this
         is a no-op when the row fits without overflow. */
      var activeItem = thumbItems[index];
      if (activeItem && typeof activeItem.scrollIntoView === 'function') {
        activeItem.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }

      /* Update aria-pressed on thumb buttons */
      thumbBtns.forEach(function (btn, i) {
        btn.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });

      activeIndex = index;

      /* Bind controls for the new slot (idempotent) */
      var bound = bindControls(slots[index]);
      currentVideo = bound ? bound.video : null;

      /* If the caller requested autoplay (thumbnail click, swipe nav), start
         playback through the shared play() so unmute behaviour is consistent. */
      if (autoplay && bound && bound.play) bound.play();
    }

    /* ── Boot ────────────────────────────────────────────────── */

    /* Bind controls for the first slot immediately */
    var initial = bindControls(slots[0]);
    if (initial) currentVideo = initial.video;

    /* Thumbnail click → switch and immediately play the new video */
    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-video-index'), 10);
        if (!isNaN(idx)) switchTo(idx, true);
      });
    });

    /* ── Touch swipe on the video player → next / prev ─────────────
       Listens to touchstart + touchend on the player element. Detects
       horizontal swipes (dx > dy + above min distance) and navigates.
       Short taps fall below the min-distance threshold so they don't
       interfere with the control buttons or seek bar. */
    var playerEl = root.querySelector('[data-video-ugc-player]');
    if (playerEl) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchActive = false;
      var minSwipeDistance = 50; /* px — below this, treat as tap */

      playerEl.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) {
          touchActive = false;
          return;
        }
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchActive = true;
      }, { passive: true });

      playerEl.addEventListener('touchend', function (e) {
        if (!touchActive) return;
        touchActive = false;

        var touchEndX = e.changedTouches[0].clientX;
        var touchEndY = e.changedTouches[0].clientY;
        var dx = touchEndX - touchStartX;
        var dy = touchEndY - touchStartY;

        /* Require horizontal-dominant swipe over the min distance threshold.
           Vertical drags (scrolling the page) and short taps are ignored. */
        if (Math.abs(dx) <= Math.abs(dy)) return;
        if (Math.abs(dx) < minSwipeDistance) return;

        if (dx < 0 && activeIndex < slots.length - 1) {
          /* Swipe left → next video (autoplay for one-gesture nav) */
          switchTo(activeIndex + 1, true);
        } else if (dx > 0 && activeIndex > 0) {
          /* Swipe right → previous video (autoplay for one-gesture nav) */
          switchTo(activeIndex - 1, true);
        }
      }, { passive: true });

      playerEl.addEventListener('touchcancel', function () {
        touchActive = false;
      }, { passive: true });
    }
  }

  /* ── Global initialiser ──────────────────────────────────────── */

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-video-ugc]').forEach(initVideoUgc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Re-run on Shopify theme editor section reload */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
